<template>
  <ListComponent title="Sub Hire Commitment" :totalCount="totalItems">
    <template #list>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
          <AgGridVue
            style="width: 100%; height: calc(100vh - 130px)"
            class="ag-theme-alpine"
            :columnDefs="headers"
            :context="context"
            @grid-ready="onGridReady"
            :defaultColDef="defaultColDef"
            :grid-options="gridOptions"
            :rowData="allList"
          />
        </v-col>
      </v-row>
    </template>
    <template #dialogs>
      <BulkUpload
        v-model="bulkUploadDialog"
        :uploadTo="uploadType"
        @refreshList="getList()"
      />
      <SubHireCommitmentEntriesDialog
        v-model="showEntriesDialog"
        :date="selectedDate"
      />
    </template>
    <template #actions>
      <v-btn
        v-if="permissions && permissions.add"
        class="ml-3"
        color="primary"
        depressed
        @click="bulkUploadDialog = true"
      >
        <v-icon>mdi-plus</v-icon>
        <span>Bulk Upload</span>
      </v-btn>
    </template>
  </ListComponent>
</template>
<script>
import ListComponent from "@/components/General/ListComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import SubHireCommitmentDateButton from "@/components/AgGridComponents/SubHireCommitmentDateButton.vue";
import CustomHeader from "@/components/AgGridComponents/General/CustomHeader.vue";
import BulkUpload from "@/components/General/BulkUpload.vue";
import SubHireCommitmentEntriesDialog from "@/components/ModuleBased/dialogs/SubHireCommitmentEntriesDialog.vue";
import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

export default {
  components: {
    ListComponent,
    agColumnHeader: CustomHeader,
    AgGridVue,
    BulkUpload,
    SubHireCommitmentDateButton,
    SubHireCommitmentEntriesDialog,
  },
  data() {
    return {
      allList: [],
      totalItems: 0,
      selectedDate: null,
      showEntriesDialog: false,
      bulkUploadDialog: false,
      uploadType: "sub_hire_commitment",
      permissions: null,
      defaultColDef: { resizable: true },
      gridOptions: {
        onGridSizeChanged: () => this.gridOptions.api.sizeColumnsToFit(),
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        rowHeight: 35,
      },
      headers: [
        { headerName: "Date", field: "date", sortable: true, minWidth: 140 },
        {
          headerName: "Total Committed",
          field: "total_committed",
          sortable: true,
          minWidth: 160,
        },
        {
          headerName: "Total Allocated",
          field: "total_allocated",
          sortable: true,
          minWidth: 160,
        },
        {
          headerName: "No. of Vendors",
          field: "entry_count",
          sortable: true,
          minWidth: 140,
        },
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "SubHireCommitmentDateButton",
          pinned: "right",
          width: 60,
        },
      ],
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    viewDateEntries(date) {
      this.selectedDate = date;
      this.showEntriesDialog = true;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getList() {
      this.$bus.$emit("showLoader", true);
      this.$api.subHireCommitment
        .getSubHireCommitmentDateSummary()
        .then((data) => {
          this.allList = data;
          this.totalItems = data.length;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("subhire_commitment");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this module!",
          color: "error",
        });
        this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
      } else {
        this.permissions = { ...permissions };
        this.getList();
      }
    }
  },
};
</script>
